import moment from "moment-timezone";

/**
 * Format date from a given date
 * @param {*} date - date to format
 * @param {*} timeZone - time zone
 * @returns formatted date
 */
export function formatDate(date, timeZone = null) {
    if (timeZone) {
        return moment(date).tz(timeZone).format("DD-MMM-YYYY");
    }
    return moment(date).format("DD-MMM-YYYY");
}

/**
 * Format time from a given date
 * @param {*} date - date to format
 * @param {*} timeZone - time zone
 * @returns formatted time
 */
export function formatTime(date, timeZone = null) {
    if (timeZone) {
        return moment(date).tz(timeZone).format("h:mm:ss (hh:mm:ss A)");
    }
    return moment(date).format("h:mm:ss (hh:mm:ss A)");
}

/**
 * Get type source based on type and role
 * @param {*} type - type of source
 * @param {*} role - user role
 * @returns formatted type source
 */
export function formatSource(appType, userRole) {
    if (["rhomtrip", "rhombuss"].includes(appType)) {
        return userRole === "supplier" ? "RhomTrip Suppliers" : "RhomTrip Internal";
    } else if (appType === "dispatch") {
        return "RhomTrip Dispatch";
    } else if (appType === "web") {
        return "RhomTrip Web";
    } else if (appType === "driver-app") {
        return "RhomTrip Driver";
    } else if (appType === "agency-app") {
        return "RhomTrip Partners";
    } else if (appType === "rhomtrip-system") {
        return "RhomTrip System";
    }
    return "-";
}

/**
 * Get user name from history object
 * @param {*} history - history object
 * @returns formatted user name
 */
export function getUserName(history) {
    try {
        if (history.responsible.type === "Customers") {
            return `${history.responsible.ref.first_name} ${history.responsible.ref.last_name}`;
        } else if (history.responsible.type === "Operators") {
            return `${history.responsible.ref.contactPerson.firstName} ${history.responsible.ref.contactPerson.lastName}`;
        } else if (history.responsible.type === "Users") {
            return history.responsible.ref ? `${history.responsible.ref.personal_info.first_name} ${history.responsible.ref.personal_info.last_name}` : "RhomTrip System";
        } else if (history.responsible.type === "Passengers") {
            return `${history.responsible.ref.first_name} ${history.responsible.ref.last_name}`;
        } else if (history.responsible.type === "Drivers") {
            if (history.responsible.ref.person) {
                return `${history.responsible.ref.person.first_name} ${history.responsible.ref.person.last_name}`;
            }
        }
        return "Unknown";
    } catch (error) {
        return "Unknown";
    }
}

/**
 * Get user role
 * @param {*} role - user role
 * @returns formatted user role
 */
export function getUserRole(role) {
    if (role === "customer") {
        return "Customer";
    } else if (role === "travel_agency") {
        return "Partner";
    } else if (role === "business") {
        return "Business";
    } else if (role === "guest") {
        return "Guest";
    } else if (role === "supplier") {
        return "Supplier";
    } else if (role === "driver") {
        return "Driver";
    } else if (role === "admin") {
        return "Admin";
    } else if (role === "super_admin") {
        return "Super Admin";
    } else if (role === "manager") {
        return "Manager";
    } else if (role === "user") {
        return "User";
    } else if (role === "supplier_access") {
        return "Supplier Access";
    } else if (role === "dispatcher_access") {
        return "Dispatcher Access";
    } else if (role === "travel_access") {
        return "Agent";
    } else if (role === "passenger") {
        return "Partner Client";
    } else if (role === "support") {
        return "Support";
    } else {
        return "Unknown";
    }
}
